import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PostTab from "./PostTab";

const EditPost = () => {
  const { slug } = useParams();

  return (
    <div className="flex-1 p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold">📝 Edit Post Details</h1>
        <Link to="/admin/posts">
          <Button
            variant="outline"
            className="hover:bg-blue-600 hover:text-white"
            aria-label="Back to Posts"
          >
            Back to Posts →
          </Button>
        </Link>
      </div>

      {slug ? (
        <PostTab slug={slug} />
      ) : (
        <p className="text-red-500">Error: Post slug not found.</p>
      )}
    </div>
  );
};

export default EditPost;
